import { InjectionToken, Provider } from '@angular/core';
import { ReferenceData } from './reference-data.types';
import { DEFAULT_REFERENCE_DATA } from './reference-data.constants';

export const REFERENCE_DATA = new InjectionToken<ReferenceData>(
    'REFERENCE_DATA'
);

export function provideReferenceDataDefaults(): Provider {
    return { provide: REFERENCE_DATA, useValue: DEFAULT_REFERENCE_DATA };
}

export function provideReferenceData(
    partial: Partial<ReferenceData>
): Provider {
    const merged: ReferenceData = { ...DEFAULT_REFERENCE_DATA, ...partial };
    return { provide: REFERENCE_DATA, useValue: Object.freeze(merged) };
}
